import cn from 'classnames';
import type { ReactNode } from 'react';
import * as checkboxStyles from '@pages/programs/publication-page/ui/checkbox/styles.module.scss';
import { Card } from '@shared/ui/index.ts';
import { IconCheckbox } from '@shared/ui/inputs/iconCheckbox/index.ts';
import * as st from './styles.module.scss';

type PT = {
  title: string;
  icon: ReactNode;
  onClick: () => void;
  isActive: boolean;
  className?: string;
};
export const CustomField = ({ icon, title, onClick, className, isActive }: PT) => {
  return (
    <Card className={cn(checkboxStyles.card, st.card, className)} onClick={onClick}>
      <div className={checkboxStyles.tag}>
        <IconCheckbox checked={isActive} />
        <div className={st.groupIcon}>{icon}</div>
        <div className={cn(checkboxStyles.tag__title)}>{title}</div>
      </div>
    </Card>
  );
};
